export var normalizeLocale = function (locale) {
    return locale.replace(/_/g, '-');
};
//# sourceMappingURL=common.js.map